module.exports = __webpack_public_path__ + "static/0040-6115835e52149432fee01fc8961e82d1.png";